import styled                     from 'styled-components';

import { ButtonVariants         } from 'src/components/common/button';
import { TagsVariants           } from 'src/components/common/tags';
import { RadioGroupVariants     } from 'src/components/common/radio-group';
import { LabeledContentVariants } from 'src/components/common/labeled-content';
import { InputMultilineVariants } from 'src/components/common/input/input-multiline';

import { cssFlexColumn,
         Typo,
         themeTypos,
         typoAsCSS,
         themeColors            } from 'src/providers/theme/shared';



type SelectionRatingLookAndFeel = {
  paddings: number[];

  captionTypo: Typo;
  captionColor: string;

  radioVariant: RadioGroupVariants;

  messageTypo: Typo;
  messageColor: string;

  labeledVariant: LabeledContentVariants;
  multilineVariant: InputMultilineVariants;

  sendButtonVariant: ButtonVariants;
  cancelButtonVariant: ButtonVariants;

  gap: number;

  tagsVariant: TagsVariants;
}

const selectionrating_light: SelectionRatingLookAndFeel = {
  paddings: [28],

  captionTypo: themeTypos.GRTSKREG_W500_S16_LH22,
  captionColor: themeColors.TextNeutralText100,

  radioVariant: 'light',

  messageTypo: themeTypos.GRTSKREG_W400_S12_LH16,
  messageColor: themeColors.TextNeutralText50,

  labeledVariant: 'blue1w400s14lh17gap4',
  multilineVariant: 'light',

  sendButtonVariant: 'primaryBig',
  cancelButtonVariant: 'textBig',

  gap: 20,

  tagsVariant: 'chipsWide',
}

export type SelectionRatingVariants = 'light';

export const selectionrating_variants: Map<SelectionRatingVariants, SelectionRatingLookAndFeel> = 
  new Map<SelectionRatingVariants, SelectionRatingLookAndFeel>([
    ['light', selectionrating_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: SelectionRatingLookAndFeel
}>`
  ${cssFlexColumn};

  padding: ${(args) => args.lookAndFeel.paddings[0]}px;
`

export const Caption = styled.div<{
  lookAndFeel: SelectionRatingLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.captionTypo)};
  color: ${(args) => args.lookAndFeel.captionColor};
`

export const Message = styled.div<{
  lookAndFeel: SelectionRatingLookAndFeel
}>`
  ${(args) => typoAsCSS(args.lookAndFeel.messageTypo)};
  color: ${(args) => args.lookAndFeel.messageColor};
`
